export default class AbTestBuckets {
  static ON = 'on';
  static OFF = 'off';
  static CA_OFF = 'california_off';
  static CONTROL = 'control';
  static EXCLUDED = 'excluded';
}

export const AbTests = {
  PREFILL_PHONE_SUBTEXT_VARIANT: 'root_web_prefill_phone_subtext_variant',
};

export class AdvertiseTestDriveAbTestBuckets {
  static CONTROL = AbTestBuckets.CONTROL;
  static COMBINATION = 'combination';
  static SAVINGS = 'savings';
  static SCORECARD = 'scorecard';
}

export class NavRedesignAbTestBuckets {
  static CONTROL = AbTestBuckets.CONTROL;
  static MENU_NAV = 'menu_nav';
  static SIMPLE_NAV = 'simple_nav';
}

export class RecentlyMovedPricingFlowAbTestBuckets {
  static CONTROL = AbTestBuckets.CONTROL;
  static PROMPT_WITH_RECENT_ADDRESS ='prompt_with_recent_address';
}

export class WebTextToDownloadAbTestBuckets {
  static PROMPT_FOR_SMS = 'prompt_for_sms';
  static SEND_SMS_IMMEDIATELY = 'send_sms_immediately';
}
